import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

/**
 * Collapsible card section. Used for BrandDetail (Identity / Story /
 * Voice & messaging / Strategy / Proof) and ProductDetail (Overview /
 * Features & Benefits / Audience). Default is expanded.
 *
 * Phase 9 — the optional ``aiFill`` slot renders a small button to the right
 * of the title. Clicks are stopped from bubbling so they don't toggle the
 * section open/closed.
 */
export function CollapsibleSection({
  title,
  subtitle,
  defaultOpen = true,
  testId,
  children,
  right = null,
  aiFill = null,
}) {
  const [open, setOpen] = useState(defaultOpen);
  const Chevron = open ? ChevronDown : ChevronRight;
  return (
    <section
      data-testid={testId}
      className="rounded-2xl border border-slate-200 bg-white shadow-sm"
    >
      <header
        role="button"
        tabIndex={0}
        onClick={() => setOpen((v) => !v)}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setOpen((v) => !v); } }}
        className="flex cursor-pointer items-center gap-3 rounded-2xl px-5 py-3 transition-colors hover:bg-slate-50"
      >
        <Chevron className="h-4 w-4 text-slate-400" strokeWidth={1.75} />
        <div className="min-w-0 flex-1">
          <h3 className="font-display text-sm font-semibold tracking-tight text-slate-900">{title}</h3>
          {subtitle ? <p className="mt-0.5 text-[11px] text-slate-500">{subtitle}</p> : null}
        </div>
        {aiFill ? (
          <div onClick={(e) => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()}>
            {aiFill}
          </div>
        ) : null}
        {right}
      </header>
      {open ? (
        <div data-testid={testId ? `${testId}-body` : undefined}
             className="space-y-5 border-t border-slate-100 px-5 py-5">
          {children}
        </div>
      ) : null}
    </section>
  );
}
